export * from './IconWaterDrop';
export { default as IconWaterDrop } from './IconWaterDrop';
